import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { Release } from '../../models/release';
import { ReleaseService } from '../../services/release/release.service';

@Injectable({ providedIn: 'root' })
export class ReleaseResolver implements Resolve<any> {
  private releaseService = inject(ReleaseService);

  resolve(route: ActivatedRouteSnapshot): Observable<Release | null> {
    const idParam = route.paramMap.get('id');
    const id = Number(idParam);

    if (!idParam || Number.isNaN(id)) {
      console.warn('Invalid release id:', idParam);
      return of(null);
    }

    return this.releaseService.getReleaseById(id).pipe(
      catchError((err) => {
        console.error('Error loading release details:', err);
        return of(null);
      }),
    );
  }
}
